<template>
  <v-dialog v-model="dialog" persistent>
    <template #activator="{on, attrs}">
        <v-btn v-on="on" v-bind="attrs" color="accent">
            Go to shipping
        </v-btn>
    </template>
    <v-card :loading="loading" :disabled="loading">
        <v-card-title>Are you ready to shipping ?</v-card-title>
        <v-card-text>
            <v-alert type="error" v-if="error">
                {{ error }}
            </v-alert>
            <v-alert type="info">
                These products are marked as built, they will be included in the invoice that will be generated
            </v-alert>
            <v-data-table
                :headers="builtHeaders"
                :items="productsBuilt"
            >
                <template #[`item.product`]="{item}" >
                    <v-tooltip bottom>
                        <template #activator="{on, attrs}">
                            <span v-on="on" v-bind="attrs">
                                {{ item.product.name }}
                            </span>
                        </template>
                        {{ item.product.sku }}
                    </v-tooltip>
                </template>
            </v-data-table>
            <v-alert color="orange" dark icon="mdi-alert">
                These products are not marked as built, they will be return to the pending box and doesn't include in the invoice that will be generated
            </v-alert>
            <v-data-table
                :headers="notBuiltHeaders"
                :items="productsNotBuilt"
            >
                <template #[`item.product`]="{item}" >
                    <v-tooltip bottom>
                        <template #activator="{on, attrs}">
                            <span v-on="on" v-bind="attrs">
                                {{ item.product.name }}
                            </span>
                        </template>
                        {{ item.product.sku }}
                    </v-tooltip>
                </template>
                <template #[`item.return`]="{item}">
                    {{ item.quantity - item.built }}
                </template>
            </v-data-table>
        </v-card-text>
        <v-card-actions>
            <v-btn @click="dialog=!dialog">
                Cancel
            </v-btn>
            <v-spacer />
            <v-btn color="accent" :disabled="productsBuilt.length == 0" @click="doMarkAsShipping">
                Go to shipping and create the invoice
            </v-btn>

        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    props: {
        handling: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        dialog: false,
        builtHeaders: [
            { text:'Product', value: 'product'},
            { text:'Built', value: 'built'},
        ],
        notBuiltHeaders: [
            { text:'Product', value: 'product'},
            { text:'In cart', value: 'return'},
        ],
        error: null
    }),
    computed: {
        ...mapGetters('handling', ['loading']),
        productsBuilt () {
            return this.handling.items.filter(item => item.built > 0)
        },
        productsNotBuilt () {
            return this.handling.items.filter(item => item.built < item.quantity)
        },
    },
    methods: {
        ...mapActions('handling', ['markAsShipping']),
        doMarkAsShipping() {
            this.error = null
            this.markAsShipping({
                id: this.handling.id
            })
            .then(({ handling }) => {
                this.$emit("input", handling);
                this.dialog = false
            })
            .catch(({data}) => {
                this.error = data.message
            })
        },
        displayAlert() {

        }
    }

}
</script>

<style>

</style>